// -- React Libraries
import React from 'react';
import MediaQuery from 'react-responsive';
import ReactFlagsSelect from 'react-flags-select';

// -- Components
import AppScoreReport from "../AppScoreReport/index";

// -- Styles
import 'react-flags-select/css/react-flags-select.css';
import StyleWrapper from "./Wrapper";

import { FLAG_LABELS, COUNTRIES } from '../../../constants/country';

export default class AppScore extends React.Component {
    constructor (props) {
        super(props);

        this.score = 0;
        for (let key in props.scores)
            this.score += props.scores[key];
    }

    render() {
        return (
            <StyleWrapper className="app-summary">
                <div className="app-score">
                    <small>APP整体分数</small>
                    <div>{this.score}/10</div>
                </div>

                <div className="app-header-controls">
                    {
                        false && this.props.report && (
                            <div className="report-border-wrapper">
                                <AppScoreReport report={this.props.report}/>
                            </div>
                        )
                    }
                    <div className="flag-border-wrapper">
                        <ReactFlagsSelect
                            className="regionInput"
                            defaultCountry={this.props.countryCode ? this.props.countryCode.toUpperCase() : "US"}
                            countries={COUNTRIES}
                            customLabels={FLAG_LABELS}
                            placeholder="Select Language"
                            showSelectedLabel={true}
                        />
                    </div>
                </div>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/AppScore/index.js